<template>
    <div class="index">
        <!-- 顶部背景图 -->
        <div class="index-bg">
            <img class="bg-image" src="../../assets/index/bg.png">
            <div class="title-box">
                <div class="title-box-left">
                    <img class="title-box-left-image" src="../../assets/index/iqinzi.png">
                    <p class="title-text">i亲子APP</p>
                    <p class="title-text2">智慧引领父母 陪孩子健康成长 </p>
                    <div class="button-box">
                        <div class="button-box-item">iOS版</div>
                        <div class="button-box-item">Android版</div>
                    </div>
                    <img class="code-box" src="../../assets/index/code.png">
                </div>
                <div class="title-box-right">
                    <img class="title-box-right-image" src="../../assets/index/moblie.png">
                </div>
            </div>
        </div>

        <!-- app介绍文案 -->
        <div class="index-text">
            <div class="index-text-left">
                “i亲子” - 深耕家庭教育领域20余年。
                在i亲子平台上，您将通过学习得到更加科学的家庭教育理念。
                在i亲子平台上，您将通过百万家长间的互助分享得到更好的教育解答。
                在i亲子平台上，您将通过被认可的专家深度解决您在家庭教育过程中的各种问题。
                让i亲子和您共育美好家庭。
            </div>
        </div>

        <!-- 底部 -->
        <div class="bottom-box">
            版权属南京小不懂科技有限公司所有 | <a target="_blank" href="https://beian.miit.gov.cn" style="color:#ffffff !important;display:inline-block;text-decoration:none;height:20px;line-height:20px;">苏ICP备2021041996号-1</a>
            <div class="bottom-text">
                <div style="width:300px;margin:0 auto; padding:22px 0 0 0;">
                    <a target="_blank" href="http://www.beian.gov.cn/portal/index.do" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
                        <img src="../../assets/index/beian.png" style="float:left;"/>
                        <p style="float:left;height:20px;line-height:20px;margin: 3px 0px 0px 5px; color:#ffffff;">苏公网安备 32011502011490号</p >
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'index',
        data() {
            return {
            }
        },
        mounted() {
            
        },
        methods: {
        },
        components: {
            
        }

    }
</script>

<style lang="less" scoped>
    .index {
        width: 100%;
        .index-bg {
            width: 100%;
            .bg-image {
                width: 100%;
                height: auto; 
                position: absolute;
                top: 0;
                left: 0;
                z-index: -1;
            }
            .title-box {
                width: 1174px;
                margin: 0 auto;
                height: 779px;
                display: flex;
                justify-content: space-between;
                padding-left: 74px;
                box-sizing: border-box;
                .title-box-left {
                    width: 423px;
                    padding-top: 100px;
                    box-sizing: border-box;
                    text-align: center;
                    .title-box-left-image {
                        width: 174px;
                        height: 174px;
                        display: inline-block;
                    }
                    .title-text {
                        margin-top: 10px;
                        font-size: 75px;
                        font-weight: 500;
                        color: #FFFFFF;
                    }
                    .title-text2 {
                        margin-top: 30px;
                        font-size: 30px;
                        font-weight: 400;
                        color: #FFFFFF;
                        line-height: 42px;
                    }
                    .button-box {
                        margin-top: 40px;
                        display: flex;
                        justify-content: space-between;
                        .button-box-item {
                            width: 201px;
                            height: 54px;
                            line-height: 54px;
                            text-align: center;
                            font-size: 18px;
                            font-weight: 500;
                            color: #FCA106;
                            background-color: #FFFFFF;
                            border-radius: 8px;
                        }
                    }
                    
                }
                .title-box-right {
                    // padding-top: 142px;
                    // box-sizing: border-box;
                    position: relative;
                    .title-box-right-image {
                        position: absolute;
                        top: 142px;
                        right: 0;
                        width: 522px;
                        height: 937px;
                    }
                }
            }
        }
        .index-text {
            width: 1174px;
            margin: 0 auto;
            margin-top: 40px;
            display: flex;
            justify-content: space-between;
            .index-text-left {
                width: 632px;
                padding-bottom: 137px;
                box-sizing: border-box;
                font-size: 25px;
                font-weight: 500;
                color: #333333;
                line-height: 36px;
            }

        }
        .bottom-box {
            width: 100%;
            height: 60px;
            background-color: #000000;
            text-align: center;
            color: #fff;
            // line-height: 60px;
            font-size: 18px;
        }
        .code-box {
            width: 100px;
            height: 100px;
            margin-top: 50px;
        }
        .bottom-text {
            display: inline-block;
        }
        
    }
</style>